export {default} from './education.vue'